import React, { useEffect, useState, useContext } from "react"
import { CssBaseline, ThemeProvider, Alert, AlertTitle, Stack } from "@mui/material"
import StyledEngineProvider from "@mui/material/StyledEngineProvider"
import { createCustomTheme } from "./theme"
import "./i18n"
import "moment/locale/id"
import Routes from "./routes"
import { Toaster } from "react-hot-toast"
import { toast } from "react-hot-toast"
import { decodeToken, isExpired } from "react-jwt"

import { onMessage } from "firebase/messaging"
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics"
import firebase from "firebase/app"

import { messaging, vapidKey } from "config/firebaseConfig"
import { NotificationContext } from "contexts/NotificationContext"
import { UserContext } from "contexts/UserContext"

let accessToken = localStorage.getItem("access_token")
let refreshToken = localStorage.getItem("refresh_token")

const App = () => {
	const theme = createCustomTheme({
		theme: "light",
		direction: "ltr",
		responsiveFontSizes: true
	})

	const { getNotifLimit, getBadge } = useContext(NotificationContext)
	const { getDataUser } = useContext(UserContext)

	useEffect(() => {
		if ("serviceWorker" in navigator) {
			navigator.serviceWorker.register("/firebase-messaging-sw.js").then((registration) => {
				const _expired = isExpired(accessToken)
				const _decodedToken = decodeToken(accessToken)

				if (_decodedToken) {
					onMessage(messaging, async (payload) => {
						console.log("Message received: ", payload)
						const params = { userid: _decodedToken.id }
						if (accessToken) {
							await getNotifLimit({ params })
							await getBadge({ params })
							toast.custom((t) => (
								<Alert
									severity="info"
									color="info"
									sx={{ minWidth: 400, bgcolor: "primary.light" }}
								>
									<AlertTitle>{payload.notification.title}</AlertTitle>
									{payload.notification.body}
								</Alert>
							))
						}
					})
				}
			})
		}

		return () => {
			// Unregister service worker on cleanup
			if (navigator.serviceWorker.controller) {
				navigator.serviceWorker.controller.postMessage({ type: "UNREGISTER" })
			}
		}
	}, [accessToken, getNotifLimit, getBadge])

	const fetchDataUser = () => {
		if (accessToken || refreshToken) {
			const tokenexpire = isExpired(accessToken)

			if (accessToken) {
				console.log("getdtauser here")
				getDataUser()
			}
		}
	}

	useEffect(() => {
		function requestPermission() {
			const currentPermission = Notification.permission
			// console.log("Requesting permission...")
			if (currentPermission === "default") {
				Notification.requestPermission().then((permission) => {
					if (permission === "granted") {
						console.log("permission granted")
						fetchDataUser()
					} else {
						console.log("permission denied")
						return
					}
				})
			} else if (currentPermission === "granted") {
				fetchDataUser()
				console.log("permission granted 2")
			} else {
				console.log("Notification permission denied.")
				return
			}
		}

		requestPermission()
	}, [])

	return (
		<StyledEngineProvider injectFirst>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				<Routes />
				<Toaster
					position="top-right"
					reverseOrder={false}
					gutter={8}
					containerClassName=""
					containerStyle={{}}
					toastOptions={{
						// Define default options
						className: "",
						duration: 5000,
						style: {
							background: "#363636",
							color: "#fff"
						},

						// Default options for specific types
						success: {
							duration: 3000,
							theme: {
								primary: "green",
								secondary: "black"
							}
						}
					}}
				/>
			</ThemeProvider>
		</StyledEngineProvider>
	)
}

export default App
